import { useState } from 'react';
import type { CompendiumSelection, JourneySection } from '../tabs/JourneyTab';

export interface JourneyState {
    section: JourneySection;
    setSection: (section: JourneySection) => void;
    selectedEntryId: string | null;
    setSelectedEntryId: (entryId: string | null) => void;
    compendiumSelection: CompendiumSelection | null;
    setCompendiumSelection: (selection: CompendiumSelection | null) => void;
}

/**
 * What is open and selected in the Journey's books. Held above the tab, so
 * it survives switching tabs.
 */
export function useJourneyState(): JourneyState {
    const [section, setSection] = useState<JourneySection>('journal');
    const [selectedEntryId, setSelectedEntryId] = useState<string | null>(null);
    const [compendiumSelection, setCompendiumSelection] = useState<CompendiumSelection | null>(null);
    return { section, setSection, selectedEntryId, setSelectedEntryId, compendiumSelection, setCompendiumSelection };
}
